import { SchoolUserRole, SubscriptionStatus } from '@novaheal/types';
import { useUser } from 'utils/auth';

/**
 * Hook to check if the current user is a teacher or guide or admin.
 * A user is considered eligible if:
 * - They have a school role of 'TEACHER' in their schoolRoles array, OR
 * - They have a school role of 'ADMIN' in their schoolRoles array, OR
 * - They have a school role of 'GUIDE' in their schoolRoles array
 */
export const useIsB2BTeacherOrAdmin = (): {
  isB2BUser: boolean | null;
  isB2BTeacherOrAdmin: boolean | null;
  isLoading: boolean;
} => {
  const { data: user, isLoading } = useUser();

  if (!user) {
    return {
      isB2BUser: null,
      isB2BTeacherOrAdmin: null,
      isLoading,
    };
  }

  const { schoolRole: userRole } = user ?? {};

  const isB2BTeacher = userRole?.roles?.includes(SchoolUserRole.TEACHER) ?? false;
  const isB2BAdmin = userRole?.roles?.includes(SchoolUserRole.ADMIN) ?? false;
  const isB2BGuide = userRole?.roles?.includes(SchoolUserRole.GUIDE) ?? false;
  // is user if the user has a voucher, but is NOT a teacher, admin or guide
  const isB2BUser = user?.subscription?.status === SubscriptionStatus.VOUCHER;

  return {
    isB2BUser,
    isB2BTeacherOrAdmin: isB2BTeacher || isB2BAdmin || isB2BGuide,
    isLoading,
  };
};
